import { fetchApplicationAttachments } from 'src/graphql/hirer/fetchApplicationAttachments';
import adCenterApiService from './adCenterApiService';
import configurationService from './configurationService';

const STATUS_SUCCESS = 0;
export const isSuccess = (data: any): boolean => data.Status === STATUS_SUCCESS;

export const addAttachmentService = async (
  prospectId: string,
  file: File,
): Promise<Record<string, any>> => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('ID', prospectId);

  const newAttachmentId: number = await adCenterApiService.post(
    configurationService.getRelativeUrl(
      '/api/v2/prospectAttachment/saveProspectAttachment',
    ),
    formData,
    undefined,
    true,
  );
  const attachments = await fetchApplicationAttachments(prospectId);
  attachments.forEach((attachment: Record<string, unknown>) => {
    if (attachment.id === newAttachmentId) {
      attachment.isNew = true;
    }
  });
  return attachments;
};
